import { Dropdown, IDropdownProps, Label, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import React from 'react';

interface IProps extends IDropdownProps {


}

const DropdownControl: React.FunctionComponent<IProps> = (props) => {

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{props.defaultValue ?? '---'}</Text>
        </div>;

    return (
        <Dropdown
            {...props}
        />
    );
}

export default DropdownControl